<script setup>
// ============================================================================
// BonBoZ: LƯỚI AN TOÀN cho các component tự viết cắm vào vỏ app.
//
// Vue mặc định: một component ném lỗi lúc render thì lỗi trồi lên tận gốc và
// TRẮNG CẢ APP. Chuyện đó vừa xảy ra thật — thêm một cụm nút lọc vào thanh trái
// mà mất luôn cả màn hình, trong khi Chatwoot phía dưới hoàn toàn lành lặn.
//
// Bọc phần của BonBoZ lại: hỏng thì mất đúng phần đó, người trực page vẫn trả
// lời khách được. Lỗi vẫn in ra console kèm tên component để còn sửa, không nuốt
// im lặng.
// ============================================================================
import { ref, onErrorCaptured } from 'vue';

const props = defineProps({
  ten: { type: String, default: 'BonBoZ' },
});

const hong = ref(false);

onErrorCaptured(loi => {
  hong.value = true;
  // eslint-disable-next-line no-console
  console.error(`[BonBoZ] ${props.ten} hỏng, đã tạm ẩn phần này:`, loi);
  return false; // chặn lỗi tại đây, không cho trồi lên làm trắng app
});
</script>

<template>
  <slot v-if="!hong" />
</template>
